// extracted by mini-css-extract-plugin
export default {"toggleContainer":"toggle_toggleContainer__FOV5s","toggleLabel":"toggle_toggleLabel__amjlD","switch":"toggle_switch__9yNgY","slider":"toggle_slider__7Ps65"};